import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ENTERPRISE_CARD } from '../../../constants/paymentMethods';
import { FUNNEL_PAYMENT_PROCESSING_STEP } from '../../../constants/funnel';

import { createOrder } from '../../../services/ebon/actions';

import ButtonComponent from '../../button/ButtonComponent';

const NextStepButton = ({
    setStateOfTransaction,
    paymentType,
    userInfo,
    partnerId,
    cartTotalValue,
    i18n,
    order,
    lock,
    createOrderRequest,
    ebon,
    createOrder
}) => {
    const disableButton = !paymentType || createOrderRequest;

    const hasFreeFacial = ebon.ebons.freeFacialValue !== undefined;

    const handleClick = () => {
        const requestedAmount = paymentType === ENTERPRISE_CARD ? cartTotalValue : null;

        createOrder(partnerId, userInfo.phoneNumber, requestedAmount, !hasFreeFacial);
    };

    // Handle order response
    useEffect(() => {
        if (order.orderState === 'created' && lock.allLocked) {
            setStateOfTransaction(FUNNEL_PAYMENT_PROCESSING_STEP);
            return;
        }
    }, [order]);

    return (
        <ButtonComponent
            color="main"
            cssClass="nextStepButton"
            text={i18n.PAYMENT_METHOD_BUTTON}
            onClick={() => handleClick()}
            disabled={disableButton}
        />
    );
};

NextStepButton.propTypes = {
    setStateOfTransaction: PropTypes.func,
    paymentType: PropTypes.string,
    userInfo: PropTypes.object,
    partnerId: PropTypes.number,
    cartTotalValue: PropTypes.number
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON,
        order: state.ebon.createdOrder,
        createOrderRequest: state.ebon.createOrderRequest,
        lock: state.ebon.lock,
        ebon: state.ebon
    };
};

const mapDispatchToProps = {
    createOrder
};

export default connect(mapStateToProps, mapDispatchToProps)(NextStepButton);



// WEBPACK FOOTER //
// ./src/components/funnel/buttons/NextStepButton.js